import { render, staticRenderFns } from "./ViewTwo.vue?vue&type=template&id=0a9878e0&scoped=true&"
import script from "./ViewTwo.vue?vue&type=script&lang=js&"
export * from "./ViewTwo.vue?vue&type=script&lang=js&"
import style0 from "./ViewTwo.vue?vue&type=style&index=0&id=0a9878e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9878e0",
  null
  
)

export default component.exports